import { useEffect } from 'react'
import { trackInternalEvent } from '@rio/tracking'
import { useI18n } from 'builder/hooks/useI18n'
import { FetchStatuses } from 'builder/modules/constants'
import noPhotoCompositionImage from '../assets/no-photo-composition.png'
import noPhotoCompositionWithoutAvatarImage from '../assets/no-photo-composition_without_avatar.svg'
import doodle from '../assets/doodle.svg'
import {
  ProfileHeaderWrapper,
  LinkedInProfileCard,
  Title,
  SubTitle,
  FullName,
  Position,
  Avatar,
  ProfileButtonContainer,
  TryAnotherLink,
  RevertIcon,
  Button,
  Container,
  CloseIconWrapper,
  CloseIcon,
  ProfileContainer,
  ImageWrapper,
  LinkedInImage,
  InfoContainer,
  LinkedInImageDoodle,
} from '../styles'
import { useCreateResumeWithLinkedin } from '../useCreateResumeWithLinkedin'
import { LOCALIZATION_KEY } from '../constants'

export const LinkedInProfile = () => {
  const { i18n } = useI18n()
  const {
    linkedInProfileData,
    handleUseAnotherLink,
    handleGenerateResumeWithLinkedIn,
    updateResumeWithLinkedInStatus,
    handleClose,
  } = useCreateResumeWithLinkedin()

  useEffect(() => {
    trackInternalEvent('see_linkedin_profile_screen', {
      label: 'li_prefill',
    })
  }, [])

  return (
    <Container>
      <CloseIconWrapper onClick={handleClose}>
        <CloseIcon />
      </CloseIconWrapper>
      <ProfileContainer>
        <LinkedInProfileCard>
          <ImageWrapper>
            {linkedInProfileData?.avatar ? (
              <>
                <Avatar src={noPhotoCompositionWithoutAvatarImage} alt="LinkedIn Avatar" />
                <LinkedInImage src={linkedInProfileData?.avatar} alt="User LinkedIn Avatar" />
                <LinkedInImageDoodle src={doodle} alt="LinkedIn Avatar Doodle" />
              </>
            ) : (
              <Avatar src={noPhotoCompositionImage} alt="LinkedIn Avatar" />
            )}
          </ImageWrapper>
          <InfoContainer>
            <FullName>{linkedInProfileData?.fullName}</FullName>
            <Position>{linkedInProfileData?.position}</Position>
          </InfoContainer>
        </LinkedInProfileCard>
        <ProfileHeaderWrapper>
          <Title>{i18n.t(`${LOCALIZATION_KEY}.validate_linkedin_profile_modal.title`)}</Title>
          <SubTitle>
            {i18n.t(`${LOCALIZATION_KEY}.validate_linkedin_profile_modal.description`)}
          </SubTitle>
        </ProfileHeaderWrapper>
      </ProfileContainer>
      <ProfileButtonContainer>
        <TryAnotherLink onClick={handleUseAnotherLink}>
          <RevertIcon />
          {i18n.t(
            `${LOCALIZATION_KEY}.validate_linkedin_profile_modal.use_another_link_button_text`,
          )}
        </TryAnotherLink>
        <Button
          onClick={handleGenerateResumeWithLinkedIn}
          isLoading={updateResumeWithLinkedInStatus === FetchStatuses.loading}
        >
          {i18n.t(`${LOCALIZATION_KEY}.validate_linkedin_profile_modal.continue_button_text`)}
        </Button>
      </ProfileButtonContainer>
    </Container>
  )
}
